import { UserAccess } from '../users/models';
export function mapBranchFromDto(branchDto) {
    const { id, axCustomerId, name, permissions, country, settings, IsoCode, contactPersonId } = branchDto;
    return {
        id,
        axCustomerId,
        name,
        access: (permissions === null || permissions === void 0 ? void 0 : permissions.admin) ? UserAccess.Admin : UserAccess.Regular,
        countryCode: country,
        useUpperCase: settings === null || settings === void 0 ? void 0 : settings.enforceUpperCaseReference,
        endUserInvoicing: settings === null || settings === void 0 ? void 0 : settings.endUserInvoicing,
        businessInvoicing: settings === null || settings === void 0 ? void 0 : settings.businessInvoicing,
        maxImageUploaded: settings === null || settings === void 0 ? void 0 : settings.maxImageUpload,
        contactPersonId,
        locale: IsoCode,
        _dto: branchDto,
    };
}
export function mapBranchToDto({ name, access, locale, _dto }) {
    return {
        ..._dto,
        name,
        IsoCode: locale,
        permissions: {
            admin: access === UserAccess.Admin,
        },
    };
}
/**
 * Into the canonical `IBranch` (`efkt/branches/models.ts`), for the same cold-load fallback shape as
 * `datahub/users/helpers.ts::mapUserToCanonicalUser`. Drops `access` (a per-user relationship, not a
 * branch field — see that canonical model's comment) and `_dto` (no Efkt branch write exists to spread
 * it back into).
 */
export function mapBranchToCanonical(branch) {
    return {
        id: branch.id,
        name: branch.name,
        countryCode: branch.countryCode,
        maxImageUploaded: branch.maxImageUploaded,
        useUpperCase: branch.useUpperCase,
        endUserInvoicing: branch.endUserInvoicing,
        businessInvoicing: branch.businessInvoicing,
        locale: branch.locale,
        contactPersonId: branch.contactPersonId,
        axCustomerId: branch.axCustomerId,
    };
}
